import React from "react"
import {MainCP} from "../../Components/cantidad-automoviles/MainCP"

const ViewCantidadAutomoviles: React.FC = () => <MainCP/>

export default ViewCantidadAutomoviles;